import styled from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const StyledActiveTriggerLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 43px;
  min-width: 43px;
  height: 43px;
  margin-right: 10px;
  border: 1px solid ${GrayColors["G-1-5"]};

  border-radius: 50%;
`;

export const StyledIntegrationLabel = styled.span`
  font-weight: 500;
`;

export const StyledTriggerLabel = styled.span`
  font-weight: 400;
  margin-right: 3px;
`;

export const StyledActionLabel = styled(StyledTriggerLabel)``;

export const StyledArrowIconWrapper = styled.div`
  width: 16px;
  height: 16px;
`;

export const StyledButtonOpenTriggerActionMenu = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 15px;
  background: ${GrayColors["G-0"]};
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 5px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 600;
  color: ${TextColorNames.primary};
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    border-color: ${GrayColors["G-2"]};
  }
`;

export const StyledButtonDisabledTriggerActionMenu = styled(
  StyledButtonOpenTriggerActionMenu,
)`
  background: ${GrayColors["G-0-5"]};
  color: ${TextColorNames.secondary};
  cursor: default;

  &:hover {
    border-color: ${GrayColors["G-1-5"]};
  }

  span {
    margin-right: 5px;
  }

  .tooltip--inline-block {
    line-height: 0;
    cursor: pointer;
  }
`;
